import React from 'react';
import { Instagram, Heart, MessageCircle, Send, ArrowRight, Check } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const InstagramPage = () => {
  const { login } = useAuth();

  const features = [
    'Automatize DMs do Instagram',
    'Responda Stories automaticamente',
    'Responda comentários em posts',
    'Responda menções em Reels',
  ];

  const useCases = [
    { title: 'Story Replies', desc: 'Engaje quem responde seus Stories' },
    { title: 'Comments Auto', desc: 'Responda comentários automaticamente' },
    { title: 'DM Automation', desc: 'Chatbot 24/7 nas mensagens diretas' },
    { title: 'Lead Capture', desc: 'Capture leads de forma automática' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        {/* Hero */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-pink-100 text-pink-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Instagram className="h-4 w-4" />
                Instagram DM
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Automatize seu <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600">Instagram</span>
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Responda DMs, Stories e comentários automaticamente. Aumente seu engajamento e vendas.
              </p>
              <div className="flex flex-wrap gap-4">
                <Button onClick={login} size="lg" className="bg-[#3b82f6] hover:bg-[#2563eb]">
                  Começar gratuitamente
                </Button>
                <Button variant="outline" size="lg">
                  Ver demonstração
                </Button>
              </div>
            </div>
            <div className="bg-gradient-to-br from-purple-600 via-pink-600 to-orange-500 rounded-3xl p-8 text-white">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
                  <Instagram className="h-6 w-6 text-pink-600" />
                </div>
                <div>
                  <p className="font-semibold">ChatAlfa Bot</p>
                  <p className="text-sm text-pink-200">Instagram DM</p>
                </div>
              </div>
              <div className="space-y-3">
                <div className="bg-white/20 backdrop-blur rounded-xl p-3">
                  <p className="text-sm">Oi! Vi que você curtiu nosso post 💕</p>
                </div>
                <div className="bg-white text-gray-900 rounded-xl p-3 ml-8">
                  <p className="text-sm">Sim! Quero saber mais!</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Features */}
        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
              Recursos do Instagram
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((feature) => (
                <div key={feature} className="bg-white rounded-xl p-6 shadow-sm">
                  <Check className="h-6 w-6 text-green-500 mb-3" />
                  <p className="font-medium text-gray-900">{feature}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Use Cases */}
        <div className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
              Casos de uso populares
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {useCases.map((uc) => (
                <Card key={uc.title} className="hover:shadow-lg transition-shadow">
                  <CardContent className="p-6">
                    <h3 className="font-semibold text-gray-900 mb-2">{uc.title}</h3>
                    <p className="text-sm text-gray-600">{uc.desc}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white">
              <CardContent className="py-12 text-center">
                <h2 className="text-2xl font-bold mb-4">Pronto para automatizar seu Instagram?</h2>
                <p className="text-blue-100 mb-6">Comece gratuitamente em minutos</p>
                <Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">
                  Começar agora <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default InstagramPage;
